import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomatherantaxiservice() {



  const cardData = {
"keyword": "Pune to Matheran Taxi Service",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Matheran Taxi Service for travelers seeking safe, scenic, and hassle-free hill station travel. Whether you are planning a weekend getaway, family trip, nature tour, or romantic vacation, our cab service ensures a smooth journey up to the nearest access points of Matheran, followed by convenient local transfer options. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Matheran. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable and scenic travel experience to Matheran via Neral route.",

"topPlaces": [
  {
    "title": "Charlotte Lake",
    "description":
      "Charlotte Lake is one of the most beautiful and serene spots in Matheran known for its calm waters and surrounding greenery. Travelers using Pune to Matheran taxi service often visit this peaceful natural attraction."
  },
  {
    "title": "Panorama Point",
    "description":
      "Panorama Point offers breathtaking 360-degree views of valleys and sunrise landscapes. Cab travelers from Pune enjoy visiting this iconic viewpoint for photography and nature experiences."
  },
  {
    "title": "Louisa Point",
    "description":
      "Louisa Point is a famous cliff viewpoint in Matheran known for stunning valley views and waterfalls in the monsoon season. Pune to Matheran cab service makes it easy to reach nearby entry points for this trek."
  },
  {
    "title": "Echo Point",
    "description":
      "Echo Point is a popular attraction where visitors can hear their voices echo across the hills. Travelers booking Pune to Matheran taxis often include this fun natural spot in their itinerary."
  },
  {
    "title": "One Tree Hill Point",
    "description":
      "One Tree Hill Point is a scenic viewpoint known for its unique lone tree and panoramic valley views. Taxi from Pune to Matheran ensures a comfortable journey to nearby access routes."
  },
  {
    "title": "Prabal Fort",
    "description":
      "Prabal Fort is a historic trekking destination near Matheran offering adventure trails and scenic views. Cab travelers from Pune often explore this fort during their nature trips."
  },
  {
    "title": "Alexander Point",
    "description":
      "Alexander Point is a peaceful viewpoint offering stunning views of the surrounding hills and valleys. Pune to Matheran taxi service provides easy access to nearby trekking routes."
  },
  {
    "title": "Neral Toy Train Route",
    "description":
      "The Neral–Matheran toy train route is a famous heritage railway experience known for scenic mountain views. Travelers from Pune often combine cab travel with this toy train ride."
  },
  {
    "title": "Porcupine Point (Sunset Point)",
    "description":
      "Porcupine Point is known for its beautiful sunset views and peaceful surroundings. Cab from Pune to Matheran makes it easy to reach the base areas for this viewpoint."
  },
  {
    "title": "Matheran Market",
    "description":
      "Matheran Market is a small and charming local shopping area offering souvenirs, food, and local items. Pune to Matheran taxi service is ideal for family and leisure trips to explore this hill station."
  }
],



services: [
  {
    name: "Pune to Matheran Cab",
    description: "Pune to Matheran cab service provides reliable transportation between Pune and Matheran with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and hill station travel ensuring smooth and safe journeys for families, tourists, and holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Matheran. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Matheran Taxi",
    description: "Pune to Matheran taxi service offers dependable transportation for passengers traveling between Pune and Matheran with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for tourism, hill station vacations, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Matheran. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Matheran",
    description: "Cab from Pune to Matheran service provides comfortable intercity transportation for passengers traveling for tourism, weekend trips, and family vacations. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Matheran. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Matheran",
    description: "Taxi from Pune to Matheran service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Matheran. Vehicles provide smooth highway and hill route travel suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Matheran. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Matheran Cab Service",
    description: "Pune to Matheran cab service provides dependable transportation solutions for passengers traveling between Pune and Matheran with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for hill station travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Matheran. Ideal for tourism, sightseeing, and weekend trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Matheran Taxi Fare",
    description: "Pune to Matheran taxi fare service provides transparent pricing information for passengers planning travel between Pune and Matheran. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Matheran. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Matheran One Way Cab",
    description: "Pune to Matheran one way cab service provides economical transportation for passengers traveling from Pune to Matheran without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for tourism, weekend getaways, and family visits. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Matheran including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Matheran Round Trip Taxi",
    description: "Pune to Matheran round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Matheran. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Matheran. Ideal for tourism, sightseeing, and family trips. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Matheran Cab Booking",
    description: "Pune to Matheran cab booking service allows passengers to reserve comfortable transportation between Pune and Matheran. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Matheran. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Matheran Cab",
    description: "Cheap Pune to Matheran cab service provides affordable transportation between Pune and Matheran with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for tourism, weekend travel, and family journeys. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Matheran. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Matheran Taxi",
    description: "Best Pune to Matheran taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth hill station travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Matheran. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Matheran Cab",
    description: "Sedan Pune to Matheran cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Matheran. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for hill station journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Matheran. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Matheran Taxi",
    description: "SUV Pune to Matheran taxi service provides spacious transportation for families and groups traveling between Pune and Matheran. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for hill station journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Matheran. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Matheran Cab",
    description: "Innova Pune to Matheran cab service provides premium SUV transportation for passengers seeking comfortable and reliable hill station travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Matheran. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Pune to Matheran Cab Package",
    description: "Pune to Matheran cab package service provides complete travel solutions for passengers planning Matheran vacations from Pune. Comfortable vehicles ensure reliable highway and hill route travel suitable for sightseeing tours, holiday trips, and family vacations. Professional chauffeurs ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Matheran. Flexible booking options allow convenient Matheran cab package reservations."
  },
  {
    name: "Pune to Matheran Tempo Traveller Package",
    description: "Pune to Matheran tempo traveller package service provides spacious group transportation for families and travel groups visiting Matheran from Pune. Tempo travellers offer comfortable seating, luggage space, and smooth highway travel suitable for long-distance group journeys. Professional chauffeurs ensure safe driving and reliable transportation services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Matheran. Flexible booking options allow convenient tempo traveller package reservations."
  }
],

tableData: [
  ["Pune to Matheran Cab", "Pune to Matheran Taxi"],
  ["Cab from Pune to Matheran", "Taxi from Pune to Matheran"],
  ["Pune to Matheran Cab Service", "Pune to Matheran Taxi Fare"],
  ["Pune to Matheran One Way Cab", "Pune to Matheran Round Trip Taxi"],
  ["Pune to Matheran Cab Booking", "Cheap Pune to Matheran Cab"],
  ["Best Pune to Matheran Taxi", "Sedan Pune to Matheran Cab"],
  ["SUV Pune to Matheran Taxi", "Innova Pune to Matheran Cab"],
  ["Pune to Matheran Cab Package", "Pune to Matheran Tempo Traveller Package"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Matheran Taxi Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Matheran taxi service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe hill station travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Matheran Cab Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Matheran taxi pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Matheran Taxi Availability",
        WhyChoosedescription: "Our Pune to Matheran taxi service operates 24 hours a day for family vacations, weekend getaways, sightseeing tours, emergency transportation, and business travel."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Taxis",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences for passengers visiting Matheran."
      },
      {
        WhyChooseheading: "One Way & Round Trip Taxi Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Matheran taxi service, round-trip bookings, sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Taxi Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Hill Station Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Matheran routes and ensure safe driving, smooth travel, and timely arrival for every hill station journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Matheran taxi service?", answer: "Pune to Matheran taxi service provides comfortable taxi transportation between Pune and Matheran for sightseeing, family trips, and weekend travel." },
    { question: "Is Pune to Matheran taxi service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Matheran taxi service." },
    { question: "Which vehicles are available for Pune to Matheran travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way taxi from Pune to Matheran?", answer: "Yes, customers can book one-way as well as round-trip Pune to Matheran taxi services." },
    { question: "Do you provide sightseeing taxi service in Matheran?", answer: "Yes, Shivai Travels provides sightseeing taxi packages for Matheran and nearby tourist attractions." },
    { question: "Are all Pune to Matheran taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Matheran taxi service online?", answer: "Yes, customers can easily book Pune to Matheran taxi service online or through phone booking." },
    { question: "Do you provide taxis for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Matheran taxi fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Matheran taxi service?", answer: "Yes, advance booking is available and recommended during weekends, monsoon seasons, and holidays." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Amit Jagtap",
      feedback:
        "Booked Pune to Matheran taxi service with Shivai Travels. Comfortable car, smooth hill station travel, and professional driver.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Poonam Kulkarni",
      feedback:
        "Excellent Pune to Matheran taxi service. Affordable pricing, clean cab, and wonderful travel experience.",
      rating: 5
    }
  ];




























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Matheran Taxi Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-matheran-taxi.jpg",
  "description": "Book Pune to Matheran taxi service for safe and comfortable hill station travel. Shivai Travels offers affordable one-way and round-trip cab booking with sedan, SUV, Innova, and luxury cab options available 24x7 for weekend and sightseeing trips.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹10/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-matheran-taxi"
  }
};







  return (
    <div>

<Helmet>
  <title>Pune to Matheran Taxi Service | Hill Station Cab Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Matheran taxi service for one-way and round trip travel. Affordable cab options including sedan, SUV, Innova, and luxury cabs available 24x7 for safe hill station trips and sightseeing."
  />

  <meta
    name="keywords"
    content="pune to matheran cab, pune to matheran taxi, cab from pune to matheran, taxi from pune to matheran, pune to matheran cab service, pune to matheran taxi fare, pune to matheran one way cab, pune to matheran round trip taxi, pune to matheran cab booking, cheap pune to matheran cab, best pune to matheran taxi, sedan pune to matheran cab, suv pune to matheran taxi, innova pune to matheran cab, Pune to Matheran Taxi Service, Pune to Matheran Cab Booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/34.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomatherantaxiservice;